import { IAppState } from '../../common/state';
import { INewbuildingLayoutWithOffers } from '../../types/residentialComplexLayouts/layoutWithOffers/layoutWithOffers';

export const residentialComplexLayoutOffersSelector = (state: IAppState): INewbuildingLayoutWithOffers | null => {
  return state.newbuildingLayoutOffers.data;
};
